import React, { useState } from "react";
import {
  initiateAddUserApi,
  checkUserEligibilityApi,
} from "../../api/users/userApi";
import { useUser } from "../../context/UserContext";
import { toast } from "react-toastify";

interface AddUserModalProps {
  onClose: () => void;
  onSuccess: (requestId: string) => void;
}

const AddUserModal: React.FC<AddUserModalProps> = ({ onClose, onSuccess }) => {
  const { user } = useUser();

  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!user?.org_id) {
      toast.error("Organization not found");
      return;
    }

    const tenantId = user.org_id;
    if (!/^[6-9]\d{9}$/.test(phone)) {
      toast.error("Enter a valid 10-digit phone number");
      return;
    }

    if (email && !/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Enter a valid email address");
      return;
    }

    try {
      setLoading(true);

      const eligibility = await checkUserEligibilityApi({
        tenantId,
        phone,
      });

      if (eligibility?.eligible === false) {
        toast.error(
          eligibility?.reason || "This user is not eligible to be added"
        );
        return;
      }

      const res = await initiateAddUserApi(tenantId, {
        target_phone: phone,
        ...(email ? { target_email: email } : {}),
        ...(name.trim() ? { target_name: name.trim() } : {}),
      });

      toast.success("Verification code sent to admin email");
      onSuccess(res.request_id);
    } catch (err: any) {
      const message = err?.response?.data?.message;

      if (message === "User already in organization") {
        toast.error("This user is already a member");
      } else if (message === "User belongs to another organization") {
        toast.error("This user belongs to another organization");
      } else if (message === "Active request exists") {
        toast.warning("A pending invitation already exists");
      } else {
        toast.error("Something went wrong. Please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal__header">
          <h3>Add a new user</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal__body">
          <div className="form-group">
            <label>
              Phone <span className="required">*</span>
            </label>
            <input
              placeholder="9876543210"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Name</label>
            <input
              placeholder="John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              placeholder="john@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {/* <div className="form-group">
            <label>Role</label>
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="">Select role</option>
              <option value="charge_point_operator">
                Charge point operator
              </option>
            </select>
          </div> */}
        </div>

        <div className="modal__footer">
          <button className="secondary-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="primary-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add new user"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
